import { useQuery } from '@tanstack/react-query';
import { CURRENCIES_KEY } from '../../utils/constants/queryKeys';
import { getCurrencies } from '../services/fn-api/Common';

export const useGetCurrencies = () => {
  return useQuery({
    queryKey: [CURRENCIES_KEY],
    queryFn: () => getCurrencies(),
  });
};
